import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { CoachingSessionDto } from "../../../models/coach/dto/coaching-session.dto";

export const COACHING_SESSION_QUERY_KEY = (sessionId: string) => ['coaching-session', sessionId];

export const useGetCoachingSession = (sessionId: string) => {
    const apiClient = useApiClient();

    return useQuery<CoachingSessionDto>({
        queryKey: COACHING_SESSION_QUERY_KEY(sessionId),
        queryFn: async () => {
            return apiClient.fetchApi<CoachingSessionDto, {}>({
                method: 'GET',
                endpoint: `coachs/coaching-sessions/${sessionId}`
            });
        },
        enabled: !!sessionId,
    });
};
